import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Button from 'react-bootstrap/lib/Button';

import { translate as t } from '../../lib/I18n';

import DimensionsStore from '../../stores/DimensionsStore';
import connectToStores from '../../helpers/connectToStores';

import Icon from '../general/Icon';
import AddressLineOne from './AddressLineOne';
import AddressLineTwo from './AddressLineTwo';
import AddressLineThree from './AddressLineThree';
import TownCity from './TownCity';
import Postcode from './Postcode';
import Country from './Country';
import PostCodeLookUp from '../customer/PostCodeLookUp';
import Address from '../../records/customer/Address';
import ValidatedFormField from '../form/ValidatedField';

const getStateFromStores = () => ({
    isMobile: DimensionsStore.isMobileWidth()
});

class BillingAddress extends React.PureComponent {
    static propTypes = {
        alwaysShowAddressFields: PropTypes.bool,
        canUseDeliveryAddress: PropTypes.bool,
        form: PropTypes.object,
        isSubForm: PropTypes.bool,
        onAddressSelected: PropTypes.func,
        onUseDeliveryAddress: PropTypes.func,
        ..._.pick(ValidatedFormField.propTypes, [
            'form',
            'onChange',
            'disabled',
            'outsideLabel',
            'visited',
            'validation'
        ]),
        className: PropTypes.string
    }

    defaultProps = {
        canUseDeliveryAddress: false,
        className: '',
        form: null,
        isSubForm: false,
        onAddressSelected: _.noop,
        onUseDeliveryAddress: _.noop,
    };

    state = {
        showAddressFields: false
    };

    componentDidUpdate(prevProps) {
        if (prevProps.alwaysShowAddressFields !== this.props.alwaysShowAddressFields) {
            if (this.props.alwaysShowAddressFields) {
                this.updateShowAddressFields(true);
            }
        }
    }

    updateShowAddressFields = value => {
        this.setState({ ...this.state, showAddressFields: value });
    }

    handleSelectAddress = address => {
        this.updateShowAddressFields(true);

        this.props.onAddressSelected(address);
    }

    handleToggleShowAddress = () => {
        this.updateShowAddressFields(!this.state.showAddressFields);
    };

    handleClearAddress = () => {
        this.props.onAddressSelected(new Address());
    };

    handleOnUseDeliveryAddress = () => {
        this.props.onUseDeliveryAddress();

        this.updateShowAddressFields(true);
    }

    render() {
        const {
            alwaysShowAddressFields,
            canUseDeliveryAddress,
            className,
            form,
            isMobile,
            isSubForm,
            outsideLabel
        } = this.props;

        const { showAddressFields } = this.state;

        const Wrapper = isSubForm ? 'div' : 'form';

        const displayAddressFields = showAddressFields || alwaysShowAddressFields;

        const colWidth = outsideLabel && !isMobile ? 6 : 12;

        return (
            <Wrapper className={ classnames('billing-address', className) }>
                <Row>
                    <Col xs={ 12 }>
                        <h3 className="payment__section-header">{t('payment.billingAddress')}</h3>
                    </Col>

                    <Col xs={ 12 }>
                        {canUseDeliveryAddress &&
                            <Button onClick={ this.handleOnUseDeliveryAddress } className="margin-bottom--sm">
                                <Icon icon="chevron" />{t('payment.billingAddress.useShippingAddress')}
                            </Button>
                        }
                    </Col>

                    <Col xs={ 12 }>
                        <React.Fragment>
                            <Row>
                                <Col xs={ 12 } className={outsideLabel ? "billing-address--outside-label" : ""}>
                                    <PostCodeLookUp
                                        country={ form.get('country') }
                                        onSelectAddress={ this.handleSelectAddress }
                                        cols={ { md: 12 } }
                                        outsideLabel={outsideLabel} />
                                    {outsideLabel && !displayAddressFields && (
                                        <div className="manual-address-btn">
                                            <Button
                                                className="btn-link"
                                                onClick={
                                                    this.handleToggleShowAddress
                                                }
                                            >
                                                {t("address.enterManually")}
                                            </Button>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <Row className="margin-bottom--sm">
                                {!outsideLabel && <Col xs={ 12 } md={ 6 } >
                                    {!displayAddressFields && (
                                        <div className="manual-address-btn">
                                            <Button
                                                className="btn-link"
                                                onClick={
                                                    this.handleToggleShowAddress
                                                }
                                            >
                                                {t("address.enterManually")}
                                            </Button>
                                        </div>
                                    )}
                                </Col>}

                                <Col xs={ 12 }>
                                    {displayAddressFields && (
                                        <Button
                                            bsStyle="default"
                                            className="btn-default pull-right"
                                            onClick={ this.handleClearAddress }
                                        >
                                            {t("address.clearAddress")}
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </React.Fragment>
                    </Col>

                    {displayAddressFields && <React.Fragment>
                        <Col xs={ colWidth }>
                            <AddressLineOne { ...this.props } required />
                        </Col>

                        <Col xs={ colWidth }>
                            <AddressLineTwo { ...this.props } />
                        </Col>

                        <Col xs={ colWidth }>
                            <AddressLineThree { ...this.props } />
                        </Col>

                        <Col xs={ colWidth }>
                            <TownCity { ...this.props } required />
                        </Col>

                        <Col xs={ colWidth }>
                            <Postcode { ...this.props } required />
                        </Col>

                        <Col xs={ colWidth }>
                            <Country { ...this.props } required />
                        </Col>
                    </React.Fragment>}
                </Row>
            </Wrapper>
        );

    }
}

export default connectToStores([DimensionsStore], getStateFromStores)(BillingAddress);



// WEBPACK FOOTER //
// ./src/components/payment/BillingAddress.js